import * as React from "react";
import { useState } from "react";

import SettingsCustomizationPanel from "../settings/SettingsCustomizationPanel";
import FlowsModal from "./FlowsModal";
import { FlowType } from "../commons/model/FlowType";
import {
  Flow,
  VirtualConsultationConfiguration,
  VirtualConsultationFlowIntegration,
} from "./model/Flow";
import sfetch from "../commons/utils/super-fetch";
import SettingVirtualConsultationIntegration from "./SettingVirtualConsultationIntegration";

const getDefaultFlowName = (flowType: FlowType) => {
  switch (flowType) {
    case FlowType.FULL_ASSESSMENT:
      return i18n["Global.Reports.Type.FullAssessment"];
    case FlowType.SMILE_ASSESSMENT:
      return i18n["Global.Reports.Type.SmileAssessment"];
    case FlowType.SMILE_SIMULATION:
      return i18n["Global.Reports.Type.SmileSimulation"];
  }
};

const SettingsWebsiteIntegration = ({
  virtualConsultationProps,
  isDmipPlatform,
}: {
  virtualConsultationProps?: VirtualConsultationConfiguration;
  isDmipPlatform: boolean;
}) => {
  const [showFlowPopup, setShowFlowPopup] = useState<boolean>(false);

  const actionButton = virtualConsultationProps &&
    virtualConsultationProps.canEdit && {
      title: i18n["Page.Settings.Customisation.Flow.Integration.Flows.Management"],
      action: () => setShowFlowPopup(true),
    };
  const closeModal = () => {
    setShowFlowPopup(false);
  };

  const VirtualConsultation = ({
    flow,
    isDmipPlatform,
  }: {
    flow: VirtualConsultationFlowIntegration;
    isDmipPlatform: boolean;
  }) => (
    <SettingVirtualConsultationIntegration flowIntegration={flow} isDmipPlatform={isDmipPlatform} />
  );

  const tabs: string[] = [];

  if (virtualConsultationProps) {
    virtualConsultationProps.flows.forEach((vc) => {
      tabs.push(vc.flow.name || getDefaultFlowName(vc.flow.type));
    });
  }

  const getFlowById = (flows: Flow[], id: String) => {
    return flows.find((flow) => flow.id === id);
  };

  const handleSave = (flows: Flow[]) => {
    closeModal();
    const flowsToInsert = [];
    const flowsToUpdate = [];
    const flowsToDelete = [];

    // Insert
    flows
      .filter((flow) => !virtualConsultationProps.flows.find((vc) => vc.flow.id === flow.id))
      .forEach((flow) =>
        flowsToInsert.push({
          name: flow.name,
          type: flow.type,
        } as Flow)
      );

    // Update
    virtualConsultationProps.flows
      .filter((vc) => getFlowById(flows, vc.flow.id))
      .forEach((vc) => flowsToUpdate.push(getFlowById(flows, vc.flow.id)));

    // Delete
    virtualConsultationProps.flows
      .filter((vc) => !getFlowById(flows, vc.flow.id))
      .forEach((vc) => flowsToDelete.push(vc.flow.id));

    sfetch(virtualConsultationProps.updateUrl, {
      method: "PUT",
      body: JSON.stringify({
        flowsToInsert,
        flowsToUpdate,
        flowsToDelete,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    }).then(() => document.location.reload());
  };

  return (
    <>
      <div className="panel with-shadow without-padding">
        <SettingsCustomizationPanel
          title={i18n["Page.Settings.Customisation.Flow.Integration.title"]}
          mainTitle={true}
          introduction={i18n["Page.Settings.Customisation.Flow.Integration.introduction"]}
          actionButton={actionButton}
          tabs={tabs}
        >
          {virtualConsultationProps &&
            virtualConsultationProps.flows.map((flow, index) => (
              <VirtualConsultation key={index} flow={flow} isDmipPlatform={isDmipPlatform} />
            ))}
        </SettingsCustomizationPanel>
      </div>
      {showFlowPopup && (
        <FlowsModal
          onModalClose={closeModal}
          onSave={handleSave}
          initialFlows={virtualConsultationProps.flows.map((it) => it.flow)}
        ></FlowsModal>
      )}
    </>
  );
};

export default SettingsWebsiteIntegration;
